if (!customElements.get('cc-delivered-cost')) {
  customElements.define(
    'cc-delivered-cost',
    class extends HTMLElement {
      connectedCallback() {
        this.btn       = this.querySelector('[data-cc-delivered-cost-toggle]');
        this.row       = this.btn ? this.btn.closest('.cc-delivered-cost__row') : null;
        this.total     = this.querySelector('[data-cc-delivered-cost-total]');
        this.installed = this.querySelector('[data-cc-delivered-cost-installed]');
        if (!this.btn || !this.total) return;

        this.baseCents    = parseInt(this.dataset.baseCents, 10)    || 0;
        this.installCents = parseInt(this.dataset.installCents, 10) || 0;

        this.btn.addEventListener('click', () => this.toggle());
      }

      toggle() {
        const next = this.btn.getAttribute('aria-pressed') !== 'true';
        this.btn.setAttribute('aria-pressed', next ? 'true' : 'false');
        if (this.row) this.row.classList.toggle('is-active', next);

        const cents = this.baseCents + (next ? this.installCents : 0);
        this.total.textContent = this.formatMoney(cents);

        if (this.installed) this.installed.hidden = !next;
      }

      formatMoney(cents) {
        // Match the Shopify "money_without_trailing_zeros" filter — $1,234 / $12,345.50
        const dollars = cents / 100;
        const hasFractional = dollars % 1 !== 0;
        const formatted = dollars.toLocaleString('en-US', {
          style: 'decimal',
          minimumFractionDigits: hasFractional ? 2 : 0,
          maximumFractionDigits: 2,
        });
        return '$' + formatted;
      }
    }
  );
}
